export class DetailDeviceHeader {
  constructor(
    public Sim1Info?: SimInfo,
    public Sim2Info?: SimInfo,
    public CapSettings?: {CapType: "group" | "device" | "temp", CapValue: number, CanEnableCapping: boolean, MonthlyCapping: boolean, FixedCapping: boolean},
    public Usage?: string,
    public Bundle?: string,
    public UsageLevel?: string,
    public DeviceNum?: string,
    public DeviceType?: string,
    public Customer?: string,
    public Merchant?: string,
    public CdrOnline?: boolean,
    public CdrLastUsage?: string | null,
    public MikrotikOnline?: boolean,
    public MikrotikLastPing?: string | null,
    public KAOnline?: boolean,
    public KALastPing?: string | null,
    public SIMs?: any[],
    public IsKa?: boolean,
    public IsCdr?: boolean,
    public IsMikrotik?: boolean,
    public ActiveSim?: string | null,
    public DeviceID?: number,
    public SerialNumber?: string,
    public IsCapped?: boolean,
    public TLSEnabled ?: boolean,
    public IMEI?: string,
  ) {}
}

export class SimInfo {
  constructor(public SimID: number, public SimCell: string, public SimNum: string, public ServiceProvider: string) {}
}
